export const enterKeyDown = (key: string) => {
  switch (key) {
    case "Enter":
      return true
    default:
      return false
  }
}
